import businessMode from './businessMode.js'
import util from '../util.js'

function getTotalMission(data){
	let headerIndexList = getHeaderIndexList(data[0],businessMode.TOTAL_HEADER_ONE);
	return getDataByHeaderIndex(data,headerIndexList);
}

function getHeaderIndexList(origin,target){
	let headerIndexList = [];
	target.forEach((item,index) => {
		headerIndexList[index] = "";
		for(let i=0;i<origin.length;i++){
			if(item === origin[i]){
				headerIndexList[index] = i;
				break;
			}
		}
	})

	return headerIndexList;
}

function getDataByHeaderIndex(origin,headerIndexList,headerList){
	let result = [headerList];
	origin.forEach((item,index) => {
		if(index !== 0){
			let temp = [];
			headerIndexList.forEach(i => {
				if(i !== '')
					temp.push(item[i]);
				else
					temp.push('');
			})
			result.push(temp);
		}
	})

	return result;
}

function getColumnIndex(origin,column){
	let columnIndex = "";
	for(let i=0;i<origin.length;i++){
		if(origin[i] == column){
			columnIndex = i;
			break;
		}
	}
	return columnIndex;
}

function getMachineCount(remark,str,no){
	let result = false;
	const sub_remark = remark.substring(remark.indexOf(str));
	const remarkList = sub_remark.split(' ');
	for(let i = 0;i<remarkList.length;i++){
		if(!util.isChinese(remarkList[i]) && remarkList[i] !== ''){
			let tempList = []
			if(remarkList[i].includes(',')){
				tempList = tempList.concat(remarkList[i].split(','));
			}else if(remarkList[i].includes('，')){
				tempList = tempList.concat(remarkList[i].split('，'));
			}else{
				tempList.push(remarkList[i]);
			}
			for(let k =0;k<tempList.length;k++){
				if(tempList[k] === no){
					result = true;
					break;
				}
			}
		}else if(util.isChinese(remarkList[i]) && remarkList[i] !== str)
			break;
	}
	return result
}

export default {
	getTotalMission,
	getHeaderIndexList,
	getColumnIndex,
	getMachineCount,
	getDataByHeaderIndex
}



//////////////////
// WEBPACK FOOTER
// ./static/business/businessUtil.js
// module id = null
// module chunks = 